import { useQuery } from '@tanstack/react-query';

import { modulosApi, modulosKeys } from '../modulos.api';

/**
 * Catálogo de módulos disponibles para el usuario.
 *
 * Se cachea durante 5 minutos: el catálogo cambia sólo cuando se ajustan
 * permisos o el plan, así que no tiene sentido pedirlo en cada navegación.
 */
export function useModulosDisponibles() {
  return useQuery({
    queryKey: modulosKeys.disponibles,
    queryFn: ({ signal }) => modulosApi.disponibles(signal),
    staleTime: 5 * 60_000,
  });
}
